function initCustomShopSwiper(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) {
    return null;
  }

  const swiperContainer = section.querySelector('.swiper');
  const productCards = section.querySelectorAll('.slide-card');
  const productsCount = productCards.length;
  const maxProducts = 3;
  const shouldCenter = productsCount <= maxProducts;

  if (!swiperContainer || productCards.length === 0) {
    return null;
  }

  if (section.swiperInstance) {
    return section.swiperInstance;
  }

  const swiper = new Swiper(swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
          // momentum: true,
          // momentumRatio: 0.5,
          // momentumBounce: false,
        },
        // watchSlidesProgress: true,
        resistanceRatio: 0,
        
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        
        navigation: {
          enabled: false,
        },
        pagination: {
          enabled: false,
        },
        
        scrollbar: {
          el: section.querySelector('.swiper-scrollbar'),
          draggable: true,
          dragSize: 'auto',
          hide: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            centeredSlides: false,
          },
          1510: {
            slidesPerView: shouldCenter ? maxProducts : 'auto',
            centeredSlides: shouldCenter,
            centeredSlidesBounds: shouldCenter,
          },
        }
      });
      
  section.swiperInstance = swiper;
  return swiper;
}



